import React from 'react';
import { Field, FTBody } from '../Fuse';

export const BlockPageEnabledView = {
    DEFAULT: <FTBody><strong>Default</strong> - use Proofpoint content.</FTBody>,
    CUSTOM: <FTBody><strong>Custom</strong> - use your custom message.</FTBody>,
};

export const BlockPageEnabledField = (props) => <Field
    label="Block Page Option"
    {...props}
/>;
